import React from "react";
import { SectionHeading } from "../SectionHeading";
import { TestimonialCard } from "../cards";
import { Button } from "../base";
import { motion } from "framer-motion";

export function TestimonialSection({
    title,
    description,
    badge,
    testimonials,
    button,
    ...rest
}) {
    return (
        <section
            className="py-24 bg-gradient-to-b from-white to-cyan-100/90 dark:from-base-950 dark:to-base-900"
            {...rest}
        >
            <div className="container max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <SectionHeading
                        align="center"
                        title={title}
                        description={description}
                        badge={badge}
                    />
                </motion.div>

                <div className="mt-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                        {testimonials &&
                            testimonials.map((item, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 40, scale: 0.97 }}
                                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                    viewport={{ once: true, margin: "-60px" }}
                                    transition={{
                                        duration: 0.5,
                                        delay: index * 0.1,
                                        ease: [0.25, 0.46, 0.45, 0.94],
                                    }}
                                >
                                    <TestimonialCard {...item} />
                                </motion.div>
                            ))}
                    </div>
                </div>

                {button && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        className="text-center mt-12"
                    >
                        <Button {...button} />
                    </motion.div>
                )}
            </div>
        </section>
    );
}